export const layoutNames = {
  main: 'Main',
  empty: 'Empty',
}
